/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coral_Warm_Toad_RestInputs */

const en_coral_warm_toad_rest = /** @type {(inputs: Coral_Warm_Toad_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login`)
};

const de_coral_warm_toad_rest = /** @type {(inputs: Coral_Warm_Toad_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login`)
};

/**
* | output |
* | --- |
* | "Login" |
*
* @param {Coral_Warm_Toad_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coral_warm_toad_rest = /** @type {((inputs?: Coral_Warm_Toad_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coral_Warm_Toad_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coral_warm_toad_rest(inputs)
	return de_coral_warm_toad_rest(inputs)
});